var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["chi-narrative-wrapper", _vm.state],
      style: {
        height: _vm.height + "px",
        width: _vm.width + "px"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "chi-narrative-window",
          style: {
            height: _vm.height - 28 + "px",
            width: _vm.width + "px"
          }
        },
        [
          _c("div", { staticClass: "chi-narrative-content" }, [
            _c("div", {
              staticClass: "chi-narrative-section edit",
              domProps: { innerHTML: _vm._s(_vm.edit_template) }
            }),
            _c("div", {
              staticClass: "chi-narrative-section view",
              domProps: { innerHTML: _vm._s(_vm.view_template) }
            })
          ])
        ]
      ),
      _c(
        "kendo-toolbar",
        { staticClass: "chi-narrative-toolbar" },
        [
          _c("kendo-toolbar-spacer"),
          _c(
            "kendo-toolbar-item",
            [
              _c(
                "kendo-button-group",
                [
                  _c(
                    "kendo-button",
                    {
                      attrs: {
                        "data-narrative-button": "true",
                        "data-send": "edit",
                        selected: _vm.edit_selected,
                        toggleable: true
                      }
                    },
                    [_vm._v("Edit")]
                  ),
                  _c(
                    "kendo-button",
                    {
                      attrs: {
                        "data-narrative-button": "true",
                        "data-send": "view",
                        selected: _vm.view_selected,
                        toggleable: true
                      }
                    },
                    [_vm._v("View")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }